
import Vue from 'vue'
import LazyLoad from 'vanilla-lazyload'
import { TARGET_SELECTOR, THRESHOLD, LOADED_SELECTOR } from '@/constants'

const lazyloadOptions = {
  elements_selector: TARGET_SELECTOR,
  threshold: THRESHOLD,
  class_loaded: LOADED_SELECTOR
}

const runLazyLoad = () => {
  if (!window.lazyLoadInstance)
    window.lazyLoadInstance = new LazyLoad(lazyloadOptions)
  window.lazyLoadInstance.update()
}

export default Vue.extend({
  props: {
    isLazy: {
      type: Boolean,
      required: false,
      default: false
    },
    showPlaceholder: {
      type: Boolean,
      required: false,
      default: false
    },
    showLoader: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  updated(): void {
    if (this.isLazy) runLazyLoad()
  },
  mounted(): void {
    if (this.isLazy) runLazyLoad()
  }
})
